import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(main)/(with-navigation-history)/catalog/product-filters.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(main)/(with-navigation-history)/catalog/products-catalog.js");
